
import React from 'react';
import { Category } from '@/types';

interface CategorySelectionWrapperProps {
  children: React.ReactNode;
  category: Category;
  isSelected: boolean;
  onSelect: (category: Category) => void;
}

export const CategorySelectionWrapper: React.FC<CategorySelectionWrapperProps> = ({
  children,
  category,
  isSelected,
  onSelect,
}) => {
  const handleSelect = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onSelect(category);
  };

  return (
    <div 
      onClick={handleSelect}
      role="button"
      tabIndex={0}
      className={`
        relative w-full 
        ${isSelected ? 'category-selected' : ''}
        transition-all duration-200
      `}
      data-selected={isSelected ? 'true' : 'false'}
    >
      {children}
    </div>
  );
};
